import React from "react";
import {Avatar, IconButton, Typography} from "@mui/material";
import Grid from '@mui/material/Grid';
import moment from "moment/moment";
import {Close} from "@mui/icons-material";
import {styled} from "@mui/system";

import {retrieveServiceTypeIcon} from "../../helpers/ServiceTypeUtils"

const TIMESLOT_DATETIME_FORMAT = "hh:mm A - DD MMMM YYYY";

export default function TimeslotHeader({selectedEvent, serviceTypeDetails, handleHeaderClose}) {

    const cardHeaderStyle = {
        display: "flex",
        alignItems: "center",
        gap: "2rem",
        width: '100%'
    }

    const ServiceTypeGrid = styled(Grid)(() =>({
        backgroundColor: serviceTypeDetails?.color,
        width: "2.5rem",
        padding: "0.25rem",
        borderRadius: "0 0.719rem 0.719rem 0px",
        fontSize: "1.125rem",
        marginLeft: "-0.625rem"
    }));

    const TitleAvatar = styled(Avatar)(() => ({
        marginLeft: 15,
        width: 18,
        height: 18,
        backgroundColor: 'white'
    }));

    return <Grid sx={cardHeaderStyle}>
        <ServiceTypeGrid>
            {serviceTypeDetails.type
              && <TitleAvatar>
                    <Grid component="img" src={retrieveServiceTypeIcon([serviceTypeDetails.type])} sx={{width: 14}} />
                </TitleAvatar>}
        </ServiceTypeGrid>
        <Typography fontWeight="bold">
            {moment(selectedEvent.from).format(TIMESLOT_DATETIME_FORMAT)}
        </Typography>
        {handleHeaderClose && <IconButton sx={{marginLeft: "auto"}} onClick={handleHeaderClose}><Close/></IconButton>}
    </Grid>;
}